<template>
    <div style="height: 100%;" :style="{ 'background-color': $vuetify.theme.themes.light.backgroundHome }">
      <Transacao style="height: 100%;"/>
    </div>
</template>

<script>
import Transacao from '../components/TransacaoOnline/TransacaoOnline'

export default {
  components: {
    Transacao
  },
  beforeMount () {
    this.$emit('loadDados')
  }
}
</script>
